var map = {
	"./about-us-banner.webp": 217,
	"./anniversary-banner-bm.webp": 1597,
	"./anniversary-banner-cn.webp": 1598,
	"./anniversary-banner-id.webp": 1599,
	"./anniversary-banner.webp": 1600,
	"./banner-01.jpg": 1601,
	"./banner-slot.jpg": 1602,
	"./bet-and-earn-banner-cn.webp": 1603,
	"./bet-and-earn-banner-indon.webp": 1604,
	"./bet-and-earn-banner-ms.webp": 1605,
	"./bet-and-earn-banner.webp": 1606,
	"./check-in-banner-cn.webp": 1607,
	"./check-in-banner-id.webp": 1608,
	"./check-in-banner-ms.webp": 1609,
	"./check-in-banner.webp": 1610,
	"./cny_2024-bm.webp": 1611,
	"./cny_2024-cn.webp": 1612,
	"./cny_2024.webp": 1613,
	"./epl-banner-cn.jpg": 1614,
	"./epl-banner-cn.webp": 1615,
	"./epl-banner-indo.jpg": 1616,
	"./epl-banner-indo.webp": 1617,
	"./epl-banner-ms.jpg": 1618,
	"./epl-banner-ms.webp": 1619,
	"./epl-banner.jpg": 1620,
	"./epl-banner.webp": 1621,
	"./games-banner-bm.webp": 1622,
	"./games-banner-cn.webp": 1623,
	"./games-banner-id.webp": 1624,
	"./games-banner.webp": 1625,
	"./lb-m-banner-cn.webp": 1626,
	"./lb-m-banner.webp": 1627,
	"./leaderboard-banner-cn.webp": 1628,
	"./leaderboard-banner.webp": 1629,
	"./lottery-banner.webp": 1630,
	"./lottery-banners-bm.webp": 1631,
	"./lottery-banners-cn.webp": 1632,
	"./lottery-banners-id.webp": 1633,
	"./lottery-banners.webp": 1634,
	"./lucky-spin-banner-cn.webp": 1635,
	"./lucky-spin-banner-ms.webp": 1636,
	"./lucky-spin-banner.webp": 1637,
	"./p2p-banner.webp": 1638,
	"./p2p-banners-bm.webp": 1639,
	"./p2p-banners-cn.webp": 1640,
	"./p2p-banners-id.webp": 1641,
	"./p2p-banners.webp": 1642,
	"./premier-league-banner-cn.webp": 1643,
	"./premier-league-banner.webp": 1644,
	"./promos-banner-cn.webp": 1645,
	"./promos-banner-indon.webp": 1646,
	"./promos-banner-ms.webp": 1647,
	"./promos-banner.webp": 1648,
	"./promos-detail-banner.jpg": 1649,
	"./side-bar-banner.jpg": 1650,
	"./uefa24-prediction-bm.webp": 1651,
	"./uefa24-prediction-cn.webp": 1652,
	"./uefa24-prediction-id.webp": 1653,
	"./uefa24-prediction.webp": 1654,
	"./vip-banner-cn.webp": 1655,
	"./vip-banner-id.webp": 1656,
	"./vip-banner-ms.webp": 1657,
	"./vip-banner.webp": 1658,
	"./winner-leaderboard-banner-cn.webp": 1659,
	"./winner-leaderboard-banner.webp": 1660,
	"./world-cup-banner-cn.webp": 1661,
	"./world-cup-banner.webp": 1662,
	"./world-cup-two-banner-cn.webp": 1663,
	"./world-cup-two-banner.webp": 1664,
	"./xmas_2023-bm.jpg": 1665,
	"./xmas_2023-cn.jpg": 1666,
	"./xmas_2023-id.jpg": 1667,
	"./xmas_2023.jpg": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;